import React, { useState, useEffect, useRef } from 'react';
import * as Styles from './ColorCards.style';
import withErrorBoundary from '@/utils/errorBoundary';
import useLocale from '@/hooks/useLocale';
import { IconCheck, IconAdd, ColorPicker } from 'gatorcomponents';

const ColorCards = ({ brandColor, formValues, setNewFormValue }) => {
  const [showColorPicker, setShowColorPicker] = useState(false);

  const colorPickerRef = useRef(null);
  const { studio: studioLocale } = useLocale();

  const { modalLogoGeneration: modalLogoGenerationLocale } = studioLocale;

  const showCustomColorSelected = formValues[brandColor]
    && formValues[brandColor].code === modalLogoGenerationLocale.customColorObject.code;

  const handleChangeColorPicker = (color) => {
    if (color.hex.length) {
      const colorObject = {
        code: modalLogoGenerationLocale.customColorObject.code,
        name: modalLogoGenerationLocale.customColorObject.name,
        background: color.hex,
      };

      setNewFormValue(brandColor, colorObject);
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (colorPickerRef.current && !colorPickerRef.current.contains(event.target)) {
        setShowColorPicker(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const onSelectColorCard = (color) => {
    const isSelected = formValues[brandColor] && formValues[brandColor].code === color.code;
    setNewFormValue(brandColor, isSelected ? '' : color);
  };

  return (
    <Styles.ColorCards>
      {modalLogoGenerationLocale.colors.map(color => (
        <Styles.ColorCard
          key={color.name}
          background={color.background}
          title={color.name}
          onClick={() => onSelectColorCard(color)}
        >
          {formValues[brandColor] && formValues[brandColor].code === color.code && (
            <Styles.SelectedColorFeedback>
              <Styles.IconCheckWrapper>
                <IconCheck color="primaryBlue" size="sm" />
              </Styles.IconCheckWrapper>
            </Styles.SelectedColorFeedback>
          )}
        </Styles.ColorCard>
      ))}

      <Styles.ColorCard
        custom
        onClick={() => setShowColorPicker(true)}
        ref={colorPickerRef}
        background={formValues[brandColor].code === 'custom' && formValues[brandColor].background}
      >
        {showCustomColorSelected ? (
          <Styles.SelectedColorFeedback>
            <Styles.IconCheckWrapper $customOption>
              <IconCheck color="primaryBlue" size="sm" />
            </Styles.IconCheckWrapper>

            <Styles.IconPlusWrapper $colorPickOpen $displayBorder={formValues[brandColor] && formValues[brandColor].code === 'custom'}>
              <IconAdd color="primaryExtraDark" size="md" />
            </Styles.IconPlusWrapper>
          </Styles.SelectedColorFeedback>
        ) : (
          <Styles.IconPlusWrapper $displayBorder={formValues[brandColor] && formValues[brandColor].code === 'custom'}>
            <IconAdd color="primaryExtraDark" size="md" />
          </Styles.IconPlusWrapper>
        )}

        <Styles.WrapperColorPicker>
          <ColorPicker
            disableAlpha
            showColorPicker={showColorPicker}
            onChange={color => handleChangeColorPicker(color)}
            color={formValues[brandColor] && formValues[brandColor].code === 'custom' && formValues[brandColor].background}
          />
        </Styles.WrapperColorPicker>
      </Styles.ColorCard>
    </Styles.ColorCards>
  );
};

export default withErrorBoundary(ColorCards, 'ColorCards');
